// config.js

export default {
    productionUrl: 'https://intranet.luquin.com.ar/',
    developmentUrl: 'http://luquin.test/',
  };